import React from 'react';
import { Globe, Linkedin } from 'lucide-react';
interface CoachCardProps {
  name: string;
  role: string;
  image: string;
  bio: string;
  specialties?: string[];
  linkedin?: string;
  website?: string;
}
export const CoachCard = ({
  name,
  role,
  image,
  bio,
  specialties,
  linkedin,
  website
}: CoachCardProps) => {
  return <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:bg-white/10" data-id="element-357">
      <img src={image} alt={name} className="w-48 h-48 rounded-full object-cover mb-6 border-2 border-white/20" data-id="element-358" />
      <div className="flex items-center gap-3 mb-2" data-id="element-359">
        <h3 className="font-outfit text-2xl font-bold text-white" data-id="element-360">{name}</h3>
        {(linkedin || website) && <div className="flex gap-2" data-id="element-361">
            {linkedin && <a href={linkedin} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" data-id="element-362">
                <Linkedin size={20} data-id="element-363" />
              </a>}
            {website && <a href={website} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" data-id="element-364">
                <Globe size={20} data-id="element-365" />
              </a>}
          </div>}
      </div>
      <p className="text-white/60 font-medium mb-4" data-id="element-366">{role}</p>
      <p className="text-white/80 mb-4 font-manrope" data-id="element-367">{bio}</p>
      {specialties && <div className="flex flex-wrap gap-2 justify-center" data-id="element-368">
          {specialties.map(specialty => <span key={specialty} className="bg-white/5 border border-white/10 px-3 py-1 rounded-full text-sm text-white/80" data-id="element-369">
              {specialty}
            </span>)}
        </div>}
    </div>;
};